/**
 * Read the actual Apple Pay Web API result without inferring it from the
 * browser name or operating system. This deliberately does not attempt to
 * create an ApplePaySession: Paystack remains the payment executor.
 */
export function readApplePayRuntimeCapability(runtime = typeof window === "undefined" ? null : window) {
  const session = runtime?.ApplePaySession;
  const snapshot = {
    applePaySessionPresent: Boolean(session),
    canMakePayments: false,
    reason: "apple_pay_session_unavailable",
  };

  if (!session || typeof session.canMakePayments !== "function") return snapshot;

  try {
    snapshot.canMakePayments = Boolean(session.canMakePayments());
    snapshot.reason = snapshot.canMakePayments ? "eligible" : "can_make_payments_false";
  } catch (error) {
    snapshot.reason = "can_make_payments_error";
    snapshot.error = error instanceof Error ? error.message : String(error || "Unknown error");
  }

  return snapshot;
}
